import { diContainer, serviceNames } from '../diContainer/diContainer';
import BopisStoresRepository from '../repositories/BopisStoresRepository';
import TransactionRepository from '../repositories/TransactionRepository';

class RemoveBopisInfoUseCase {
  private bopisStoresRepository: BopisStoresRepository;

  private transactionRepository: TransactionRepository;

  constructor() {
    this.bopisStoresRepository = diContainer.get(serviceNames.bopisStoresRepository);
    this.transactionRepository = diContainer.get(serviceNames.transactionRepository);
  }

  public async execute(): Promise<void> {
    const transaction = await this.transactionRepository.getTransaction();
    if (transaction.isBopisOrder) {
      await this.bopisStoresRepository.removeBopisInfo();
      await this.transactionRepository.loadTransaction();
    }
  }
}

export default RemoveBopisInfoUseCase;
